import { FaApple } from "react-icons/fa";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { MdQrCodeScanner } from "react-icons/md";
import { BsShieldCheck } from "react-icons/bs";
import { HiOutlineBadgeCheck } from "react-icons/hi";
import { FiZap } from "react-icons/fi";

// ── Replace with your actual image import ────────────────────────────────────
import mobileAppImage from "../assets/mobile-mockup-provinyx.png";
// ─────────────────────────────────────────────────────────────────────────────

const features = [
  { icon: <MdQrCodeScanner />, title: "Instant Scanning", desc: "Scan QR codes, or barcodes directly from your phone" },
  { icon: <BsShieldCheck />, title: "Verify Authenticity", desc: "Confirm product genuineness with blockchain verification" },
  { icon: <HiOutlineBadgeCheck />, title: "Complete Product Data", desc: "Access full DPP including materials, origin, and certifications" },
  { icon: <FiZap />, title: "Circularity Services", desc: "Connect with repair, recycle, and resale services instantly" },
];

function MobileApp() {
  return (
    <section className="py-20 sm:py-28 bg-gradient-to-br from-white via-blue-50 to-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">

        {/* ── LEFT ──────────────────────────────────── */}
        <div>
          <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            📱 Mobile App
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Download the Provinyx App
          </h2>

          <p className="text-gray-500 mt-5 text-base sm:text-lg leading-relaxed">
            Empower consumers to verify product authenticity, access complete Digital Product Passports,
            and engage with circularity services — all from their mobile device.
          </p>

          <div className="mt-8 space-y-5">
            {features.map((f, i) => (
              <div key={i} className="flex items-start gap-4">
                <div className="w-11 h-11 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center text-xl flex-shrink-0">
                  {f.icon}
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm sm:text-base">{f.title}</h4>
                  <p className="text-gray-500 text-xs sm:text-sm mt-0.5">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Store buttons */}
          <div className="flex gap-3 mt-8 flex-wrap">
            <button className="flex items-center gap-3 bg-black text-white px-5 py-3.5 rounded-xl hover:bg-gray-900 transition">
              <FaApple size={20} />
              <div className="text-left">
                <p className="text-xs text-gray-400">Download on the</p>
                <p className="font-semibold text-sm">App Store</p>
              </div>
            </button>
            <button className="flex items-center gap-3 bg-black text-white px-5 py-3.5 rounded-xl hover:bg-gray-900 transition">
              <IoLogoGooglePlaystore size={20} />
              <div className="text-left">
                <p className="text-xs text-gray-400">GET IT ON</p>
                <p className="font-semibold text-sm">Google Play</p>
              </div>
            </button>
          </div>

          {/* QR card */}
          <div className="mt-8 bg-white shadow-md rounded-2xl p-4 flex items-center gap-4 w-fit border border-gray-100">
            {/* <div className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center text-2xl text-gray-500">
              <MdQrCodeScanner />
            </div> */}
            <div>
              <h4 className="font-semibold text-gray-900 text-sm">Launching Soon</h4>
              <p className="text-gray-400 text-xs mt-0.5">Stay Tuned</p>
            </div>
          </div>
        </div>

        {/* ── RIGHT — Image + floating tags ─────────── */}
        <div className="relative flex justify-center items-center">

          {/* White card behind image */}
          <div className="relative rounded-3xl p-4 w-full max-w-lg transition-transform duration-700 ease-out hover:scale-[1.02]">
            <img
              src={mobileAppImage}
              loading="lazy"
              alt="Provinyx Mobile App"
              className="w-full rounded-2xl object-contain"
            />
          </div>

          {/* Floating badge — top right */}
          <div
            className="absolute -top-4 -right-4 sm:top-4 sm:right-[-2rem] bg-green-500 text-white px-4 py-2 rounded-full shadow-xl text-sm font-semibold whitespace-nowrap"
            style={{ animation: "float 3s ease-in-out infinite" }}
          >
            ✓ Verified Authentic
          </div>

          {/* Floating badge — bottom left */}
          <div
            className="absolute -bottom-4 -left-4 sm:bottom-4 sm:left-[-2rem] bg-blue-600 text-white px-4 py-2 rounded-full shadow-xl text-sm font-semibold whitespace-nowrap"
            style={{ animation: "float 3s ease-in-out infinite", animationDelay: "1.5s" }}
          >
            100% Sustainable
          </div>

        </div>

      </div>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px);  }
          50%       { transform: translateY(-10px); }
        }
      `}</style>
    </section>
  );
}

export default MobileApp;